import { useEffect, useState } from "react";

export function useModifierKeyLabel() {
  const [label, setLabel] = useState("Ctrl ");
  useEffect(() => {
    if (/Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent)) {
      setLabel("⌘");
    }
  }, []);
  return label;
}

/** Toggles the menu on ⌘K / Ctrl+K. */
export function useCommandMenuHotkey(setOpen: (fn: (open: boolean) => boolean) => void) {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key.toLowerCase() === "k" && (event.metaKey || event.ctrlKey)) {
        event.preventDefault();
        setOpen((open) => !open);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [setOpen]);
}
